const tableData = {
    invoice_post:{
        data: [],
        selected: [],
        count: 0,
        loading:false,
        isFullscreen:false,
        pagination: {rowsPerPage: 0, page_number: 20},
        columns: [
            {name: 'BillingNo', align: 'left', label: '发票票号', field: 'BillingNo', sortable: true},
            {name: 'read_at', align: 'left', label: '上报日期', field: 'read_at', sortable: true},
            {name: 'rewrited', align: 'left', label: '发送状态', field: 'rewrited', sortable: true },
            {name: 'send_time', align: 'left', label: '发送时间', field: 'send_time', sortable: true, format: (val) => `${val ? val.toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : '无'}`},
            {name: 'read_at', align: 'left', label: '文件读取时间', field: 'read_at', sortable: true, format: (val) => `${val ? val.toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') : '无'}`},
            {name: 'TOTAL', align: 'left', label: '项目行数', field: 'TOTAL', sortable: true},
            {name: 'BATCH', align: 'left', label: '单据批次', field: 'BATCH', sortable: true},
            {name: 'CODE', align: 'left', label: '状态码', field: 'CODE', sortable: true},
            {name: 'MESSAGE', align: 'left', label: '状态提示', field: 'MESSAGE', sortable: true},
            {name: 'filename', align: 'left', label: '文件名称', field: "filename", sortable: true},
        ]
    }
}
const state = () => ({
    invoice: Object.assign({}, tableData),
})
const getters = {
    getInvoicePost: state => state.invoice.invoice_post,
}
const mutations ={
    setList(state, data) {
        state.invoice.invoice_post.pagination.rowsNumber = data.count
        state.invoice.invoice_post.data = data.data
        state.invoice.invoice_post.selected = [data.data[0]]
    },
    ['refreshTableHeight'](state, data) {
        state.invoice.invoice_post.maxHeight = (data -35) + 'px';
        state.invoice.invoice_post.height = (data -35) + 'px'
    },
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState }, payload) {
        if (state.invoice.invoice_post.loading == true) return
        let msg = { command: "invoice__list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        state.invoice.invoice_post.loading = true
    },
    async ['return_invoice__list']({ state, commit }, payload) {
        state.invoice.invoice_post.loading = false;
        if (payload.success) {
            commit('setList', payload.data)
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        state.invoice.invoice_post.loading = true
        let msg = { command: "invoice__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_invoice__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
        state.invoice.invoice_post.loading = false;
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
